import { Link } from 'react-router-dom';

const LinkToProfile = (props) => {
  const { clubMembership, clubPackage } = props;
  if (!clubMembership) {
    return null;
  }
  if (!clubPackage || clubPackage.itemChoice === 'Set Items') {
    return (
      <div className="c7-checkout-summary__buttons">
        <Link to="/profile" className="c7-button">
          Visit Your Profile
        </Link>
      </div>
    );
  }
  return (
    <div className="c7-checkout-summary__buttons">
      <Link
        to={`/profile/club-membership/${clubMembership.id}/shipment`}
        className="c7-button c7-button-button--adjust"
      >
        Adjust Your Shipment
      </Link>
    </div>
  );
};

export default LinkToProfile;
